import React, { lazy, Suspense } from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Loader from './components/loader/Loader';
import './_global.scss';
import HeatPumps from './views/heating/HeatPumps';

const Main = lazy(() => import('./Main'));
const Home = lazy(() => import('./views/home/Home'));
const Furnaces = lazy(() => import('./views/heating/Furnaces'));
const FurnaceRepair = lazy(() => import('./views/heating/FuranceRepair'));
const AirConditioning = lazy(() => import('./views/cooling/AirConditioning'));
const AirConditionerRepairs = lazy(
  () => import('./views/cooling/AirConditionerRepairs'),
);
const DuctlessAirConditioners = lazy(
  () => import('./views/cooling/DuctlessAirConditioners'),
);
const WaterHeaters = lazy(() => import('./views/water/WaterHeaters'));
const WaterHeaterRepairs = lazy(
  () => import('./views/water/WaterHeaterRepairs'),
);
const WaterSoftners = lazy(() => import('./views/water/WaterSoftners'));
const AirCleaners = lazy(() => import('./views/air/AirCleaners'));
const Humidifiers = lazy(() => import('./views/air/Humidifiers'));
const Ventilators = lazy(() => import('./views/air/Ventilators'));
const Maintenance = lazy(() => import('./views/maintenance/Maintenance'));
const ContactUs = lazy(() => import('./views/contactUs/ContactUs'));

const SuspenseWrapper = ({
  fallback,
  children,
}: {
  fallback?: React.ReactNode;
  children: React.ReactNode;
}) => <Suspense fallback={fallback ?? <Loader />}>{children}</Suspense>;

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <SuspenseWrapper>
                <Main />
              </SuspenseWrapper>
            }
          >
            {/* HOME */}
            <Route
              index
              element={
                <SuspenseWrapper>
                  <Home />
                </SuspenseWrapper>
              }
            />
            <Route
              path="/furnaces"
              element={
                <SuspenseWrapper>
                  <Furnaces />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/furnace-repair"
              element={
                <SuspenseWrapper>
                  <FurnaceRepair />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/heat-pumps"
              element={
                <SuspenseWrapper>
                  <HeatPumps />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/air-conditioners"
              element={
                <SuspenseWrapper>
                  <AirConditioning />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/air-conditioner-repairs"
              element={
                <SuspenseWrapper>
                  <AirConditionerRepairs />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/ductless-air-conditioners"
              element={
                <SuspenseWrapper>
                  <DuctlessAirConditioners />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/water-heaters"
              element={
                <SuspenseWrapper>
                  <WaterHeaters />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/water-heater-repairs"
              element={
                <SuspenseWrapper>
                  <WaterHeaterRepairs />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/water-softners"
              element={
                <SuspenseWrapper>
                  <WaterSoftners />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/air-cleaners"
              element={
                <SuspenseWrapper>
                  <AirCleaners />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/humidifiers"
              element={
                <SuspenseWrapper>
                  <Humidifiers />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/ventilators"
              element={
                <SuspenseWrapper>
                  <Ventilators />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/maintenance"
              element={
                <SuspenseWrapper>
                  <Maintenance />
                </SuspenseWrapper>
              }
            />

            <Route
              path="/contact-us"
              element={
                <SuspenseWrapper>
                  <ContactUs />
                </SuspenseWrapper>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
